"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _ListSubheader = _interopRequireDefault(require("@material-ui/core/ListSubheader"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactWaypoint = _interopRequireDefault(require("react-waypoint"));

var _Container = _interopRequireDefault(require("../Container/Container"));

var _Typography = _interopRequireDefault(require("../Typography/Typography"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  line-height: 48px;\n  margin: 0;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  width: 100%;\n  background: ", ";\n  font-weight: ", ";\n  box-shadow: ", ";\n  transition: box-shadow ", "ms\n    ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var StyledMuiListSubheader = (0, _styledComponents.default)(_ListSubheader.default)(_templateObject(), function (props) {
  return props.theme.palette.common.black;
}, function (props) {
  return props['data-isontop'] && props.theme.palette.background.paper;
}, function (props) {
  return props.theme.typography.fontWeightBold;
}, function (props) {
  return props['data-isontop'] ? "".concat(props.theme.shadows[5], ", 0px -1px 0px ").concat(props.theme.palette.background.paper) : props.theme.shadows[0];
}, function (props) {
  return props.theme.transitions.duration.shortest;
}, function (props) {
  return props.theme.transitions.easing.easeInOut;
});
var StyledTypography = (0, _styledComponents.default)(_Typography.default)(_templateObject2());

var ListSubheader =
/*#__PURE__*/
function (_Component) {
  _inherits(ListSubheader, _Component);

  function ListSubheader() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ListSubheader);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ListSubheader)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      isOnTop: null
    };
    return _this;
  }

  _createClass(ListSubheader, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var isOnTop = this.state.isOnTop;

      var _this$props = this.props,
          children = _this$props.children,
          props = _objectWithoutProperties(_this$props, ["children"]);

      return _react.default.createElement(_react.Fragment, null, _react.default.createElement(_reactWaypoint.default, {
        onEnter: function onEnter() {
          return _this2.setState({
            isOnTop: false
          });
        },
        onLeave: function onLeave() {
          return _this2.setState({
            isOnTop: true
          });
        }
      }), _react.default.createElement(StyledMuiListSubheader, Object.assign({}, props, {
        "data-isontop": isOnTop
      }), _react.default.createElement(_Container.default, null, _react.default.createElement(StyledTypography, {
        variant: "h6"
      }, children))));
    }
  }]);

  return ListSubheader;
}(_react.Component);
/** @component */


var _default = ListSubheader;
exports.default = _default;